import { App } from 'vue';
import PtDrawer from './src/index.vue';

PtDrawer.install = (app: App): void => {
    app.component(PtDrawer.name, PtDrawer);
};

export default PtDrawer;

declare module 'vue' {
    export interface GlobalComponents {
        PtDrawer: typeof PtDrawer;
    }
}
